{
  "deviceBasicInfoTab": {
    "required": "Enter a device name.",
    "label2": "Area",
    "label3": "Device ID",
    "label4": "Optional features",
    "label8": "Device name",
    "label9": "Serial number (optional)",
    "label10": "Reference number (optional)",
    "label11": "Memo (optional)"
  },
  "deviceEditDialog": {
    "enqueueSnackbar": "Device information updated",
    "enqueueSnackbar2": "Video settings updated",
    "text2": "The video settings couldn't be updated.",
    "enqueueSnackbar3": "IP camera settings updated",
    "text3": "The IP camera settings couldn't be updated.",
    "label": "Basic info",
    "label2": "Video settings",
    "label3": "IP camera settings",
    "label4": "Recording upload",
    "label5": "Viewers",
    "text4": "Updating...",
    "title": "Edit camera",
    "renderPlaceholder": "Recording upload settings",
    "renderPlaceholder2": "Recording upload settings will be available in a future update.",
    "text5": "The device information couldn't be updated."
  },
  "deviceFilterBar": {
    "placeholder": "Search by device name"
  },
  "deviceIpCameraTab": {
    "label": "On",
    "label2": "Off",
    "text": "Loading...",
    "text2": "This device has no IP camera settings.",
    "text3": "The IP camera settings couldn't be retrieved.",
    "label3": "Auto return",
    "text4": "When on, the camera automatically returns to its home position after each operation.",
    "text5": "Updating the settings restarts the camera."
  },
  "deviceMoveDialog": {
    "text": "Existing clips are automatically moved to Archive and can be viewed only by global administrators.",
    "text2": "If you use cloud recording (optional), cloud recording data is deleted.",
    "text3": " users)",
    "text4": "Viewers",
    "text5": "Loading...",
    "text6": "The viewers couldn't be retrieved.",
    "button": "Reload",
    "text7": "No users can view this device",
    "text8": "Destination area",
    "text9": "Local recording data",
    "text10": "View permissions",
    "text11": "Select an area.",
    "enqueueSnackbar": "The user information couldn't be retrieved.",
    "text12": "Selected area",
    "enqueueSnackbar2": "Moving {{deviceName}} to {{destinationName}}.",
    "text13": "{{deviceName}} couldn't be moved to the new area.",
    "enqueueSnackbar3": "Some items aren't selected. Select all items.",
    "text14": "Move {{deviceName}} to another area",
    "text15": "The area move failed.",
    "text16": " Contact an administrator at this address.",
    "menuItem": "The area information couldn't be retrieved.",
    "text17": "Moving...",
    "text18": "Move to area",
    "button2": "Confirm"
  },
  "deviceQualityTab": {
    "label": "None",
    "label2": "Enabled",
    "label3": "Disabled",
    "text": "Local recording",
    "text2": "Recording",
    "text3": "Loading...",
    "text4": "This device has no video settings.",
    "text5": "The video settings couldn't be retrieved.",
    "label4": "Rotation",
    "label5": "Streaming - bitrate",
    "label6": "{{recordingLabelPrefix}} - bitrate",
    "label7": "{{recordingLabelPrefix}} - timestamp",
    "text6": "A higher bitrate increases network traffic. Choose a setting that suits your environment.",
    "text7": "Updating the settings restarts the camera."
  },
  "deviceTable": {
    "label": "Device name",
    "label2": "Area",
    "label3": "Camera type",
    "text": "Moving area",
    "text2": "Move area"
  },
  "deviceTableHeader": {
    "text": " devices"
  },
  "deviceUserListPopover": {
    "unknownRoleLabel": "Other",
    "text2": "No users",
    "text3": "No matching users",
    "title": "Users of {{deviceName}}",
    "placeholder": "Search by name, email, or role"
  },
  "deviceUsersTab": {
    "text": "No users can view this device",
    "text2": "Grant users view permission for this device in user management.",
    "placeholder": "Search by name, email, or role",
    "text3": "Name",
    "text4": "Email address",
    "text5": "Role",
    "text6": "No matching users",
    "text7": "To change a user's view permissions, edit the user in user management."
  },
  "device": {
    "title": "Camera management"
  },
  "buildChangeAreaConfirmModel": {
    "text": "Unknown",
    "label": "Don't delete",
    "text2": "Reset"
  },
  "deviceOptions": {
    "recordRetentionFallbackLabel": "30 days",
    "text": "{{value}} months",
    "text2": "None",
    "push": "PTZ control",
    "push2": "Calling",
    "push3": "Scheduled recording",
    "push4": "Cloud recording ({{value}})"
  },
  "moveDeviceOptions": {
    "label": "Delete",
    "description": "Deleted recording data stored on the device can't be restored.",
    "label2": "Don't delete",
    "description2": "Recording data on the device is kept as is.",
    "label3": "Reset",
    "description3": "View permissions are reset.",
    "label4": "Don't reset",
    "description4": "Current viewers keep their permissions.",
    "moveOptionPlaceholder": "Select"
  }
}
